import React from 'react';
import { Icon } from 'antd';

const colorError = '#f04134'; //color vermell
const colorAlerta = '#ffbf00'; //color groc

export const IconaAlerta = props => {
    return <Icon type="exclamation-circle-o" {...props} style={{ color: colorAlerta }} />;
};

export const IconaError = props => {
    return <Icon type="exclamation-circle-o" {...props} style={{ color: colorError }} />;
};


// WEBPACK FOOTER //
// ./src/components/commons/icones.js